/* app/js/src/components/monitoring/targets/target-details-popup/target-details-popup.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  position: absolute;
  z-index: 22;
  top: 15vh;
  left: 23vw;
}
.container {
  position: absolute;
  transition: opacity ease-in 0.2s;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
  transform: translate(32%, 50%);
}
.container .header {
  cursor: move;
  background-color: #141b22;
  color: white;
  height: 6%;
  padding-left: 1vw;
  padding-right: 0.5vw;
}
.container .header .window-buttons {
  margin-top: 0.3vw;
}
.container .header h2 {
  margin: 0;
}
.container .body {
  height: 74%;
  background-color: white;
  padding-left: 2vw;
  padding-right: 2vw;
  padding-top: 10px;
}
.container .footer {
  height: 20%;
  padding-left: 2vw;
  padding-right: 2vw;
}
.container .y-label {
  text-align: left;
  font-weight: bold;
  font-size: 30px;
}
/*# sourceMappingURL=target-details-popup.component.css.map */
